import * as React from "react";
import { FastField } from "formik";
import { FormGroup } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { Switch } from "@lib/components";
import { Input } from "@lib/components";
import { MobxComponent } from "../../../../../../../mobx/components/index";
import { inject, observer } from "mobx-react";
import { RestaurantForm } from "../../../../../../../mobx/components/restaurant-form";
import { UI } from "../../../../../../../core/ui";
import { PaymentBaseFields } from "./base";

interface Props { }
interface State { }
type FormValues = T.Schema.Restaurant.Payments.RestaurantPaymentRedDot;

@inject("store") @observer
export class SettingsFormPaymentsRedDot extends MobxComponent<Props, State> {

	initialValues: FormValues;

	constructor(props: Props) {
		super(props);
		this.state = {};
		const r = this.injected.store.restaurant!;
		this.initialValues = r.settings.payments.red_dot || {
			enabled: false,
			label: "",
			services: [],
			testing: false,
			merchant_id: "",
			secret_key: "",
		};
	}

	render() {
		return (
			<RestaurantForm<FormValues>
				submit={async (r, values) => {
					r.settings.payments.red_dot = values;
					const update = { $set: { "settings.payments.red_dot": r.settings.payments.red_dot } };
					return { r, update };
				}}
				validators={{}}
				initialValues={this.initialValues}
				onSuccess={() => {
				}}
				onError={() => UI.notification.error("An error occurred")}
				onSuccessMessage="Settings Updated"
				onErrorMessage="">
				{({ form, error }) => {
					const { isSubmitting, setFieldValue } = form;
					return (
						<div className="p-4">
							<FastField
								name="enabled"
								render={({ field }: any) => (
									<React.Fragment>
										<FormGroup
											title="Enabled"
											help="Allows customers to pay using this method">
											<Switch
												id="enable-switch"
												checked={field.value}
												onChange={(e) => setFieldValue("enabled", e.target.checked)} />
										</FormGroup>
									</React.Fragment>
								)}
							/>

							<FastField
								name="testing"
								render={({ field }: any) => (
									<React.Fragment>
										<FormGroup
											title="Testing Environment"
											help="Enable this to use the Red Dot Payment demo environment to test and experiment with your integration.">
											<Switch
												id="testing-switch"
												checked={field.value}
												onChange={(e) => setFieldValue("testing", e.target.checked)} />
										</FormGroup>
									</React.Fragment>
								)}
							/>

							<FastField
								name="merchant_id"
								render={({ field }: any) => (
									<React.Fragment>
										<FormGroup
											title="Merchant ID"
											help="The merchant ID given by RDP when setting up an account.">
											<Input type="text" {...field} autoSave="false" autoCorrect="false" />
										</FormGroup>
									</React.Fragment>
								)}
							/>

							<FastField
								name="secret_key"
								render={({ field }: any) => (
									<React.Fragment>
										<FormGroup
											title="Secret Key"
											help="The secret key given by RDP when setting up an account.">
											<Input type="text" {...field} autoSave="true" autoCorrect="false" />
										</FormGroup>
									</React.Fragment>
								)}
							/>

							<PaymentBaseFields
								defaultLabel="Red Dot Payment"
								setFieldValue={setFieldValue}
							/>

							{error && <FormGroup error={error} />}

							<Button full={true} color="primary" type="submit" disabled={isSubmitting}>
								{isSubmitting && <RotateLoader size={2} color="white" />}
								{!isSubmitting && "Save"}
							</Button>
						</div>
					);
				}}
			</RestaurantForm>
		);
	}
}
